import React from 'react';
import './Banner.css'
import baloon from '../../images/baloon.png'
import Particles from "react-tsparticles";
import Typical from 'react-typical';




const Banner = () => {
    const particlesInit = (main) => {
        console.log(main);
    
        // you can initialize the tsParticles instance (main) here, adding custom shapes or presets
      };
    
      const particlesLoaded = (container) => {
        // console.log(container);
      };
   
    return (
        <div id='home' style={{backgroundColor:'rgb(30, 30, 40)', width:'100%',height:'100vh'}}>
           <Particles
      id="tsparticles"
      init={particlesInit}
      loaded={particlesLoaded}
      
      options={{
        
        
        fpsLimit: 120,
        
          fullScreen: { enable: false },
          /* all other options */
       
        interactivity: {
          events: {
            onClick: {
              enable: true,
              mode: "push",
            },
            onHover: {
              enable: true,
              mode: "repulse",
            },
            resize: true,
          },
          
          modes: {
            bubble: {
              distance: 400,
              duration: .8,
              opacity: 0.7,
              size: 20,
            },
            push: {
              quantity: 2,
            },
            repulse: {
              distance: 100,
              duration: 0.5,
            },
          },
        },
        particles: {
          color: {
            value: "#ffffff",
          },
          links: {
            color: "#ffffff",
            distance: 50,
            enable: true,
            opacity: 0.8,
            width: 2,
          },
          collisions: {
            enable: true,
          },
          move: {
            direction: "none",
            enable: true,
            outMode: "bounce",
            random: false,
            speed: 1,
            straight: false,
          },
          number: {
            density: {
              enable: true,
              area: 1500,
            },
            value: 80,
          },
          opacity: {
            value: 0.5,
          },
          shape: {
            type: "circle",
          },
          size: {
            random: true,
            value: 3,
          },
        },
        detectRetina: true,
      }}
      className= 'position-absolute w-100 h-100 d-none d-lg-block'
    />

  
           <div className='row' style={{}}>
           <div className='col'>
           
           </div>
           <div  className='col-md-12 col-sm-12' style={{color:'white',display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column',marginTop:'200px'}}>
           {/* data-aos="zoom-in" data-aos-duration="3000" */}
               <div style={{fontWeight:'500px' , position:'relative'}} >
               <p style={{fontSize:'30px'}}><span style={{color:'#cc6666',fontSize:'30px'}}>Hi </span>Im Faraz</p>
               <h1 style={{fontSize:'40px'}}> 
               <Typical
                steps={['React JS developer', 1000, 'MERN Stack Developer', 1000, 'Web designer', 1000]}
                loop={Infinity}
                wrapper="b"
              />
               </h1>
              
               </div>
               <div>
               
               <button className=" success mt-3 mx-2" ><a class='anchor' style={{textDecoration:'none' , position:'relative'}} href='https://drive.google.com/uc?export=download&id=1q9qnnQ2lbkKXE8fX8HvKYPbTWqTpBZLr'>Download resume</a></button>
               <button className=" success mt-3 mx-2" ><a class='anchor' style={{textDecoration:'none' , position:'relative'}} href='#contact'>Contact me</a></button>
             
               
               </div>
           </div>
           {/* <div className='col-md-6 col-sm-12' style={{marginTop:'100px'}}>
               
           </div> */}
           </div>
            
        </div>
    );
};

export default Banner;